import React, { useState, useContext } from "react";
import classes from "./Actions.module.css";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoNotDisturbOnRoundedIcon from "@mui/icons-material/DoNotDisturbOnRounded";
import ActionModal from "./ActionModal";
import {
  extractDomain,
  sortRecommendedActionsData,
} from "../../../../utils/helpers";
import { OVERVIEW_LLM_LABELS } from "../../../../utils/constant";
import { AuthContext } from "../../../../context/auth-context";
import { getNonActionableMetricData } from "../../../../services/apiService";
import NonActionModal from "./NonActionDataModal";
import { DiscoveryContext } from "../../../BrandAudit/discovery-context";
import { ENTITY_LABELS } from "../../../../utils/labelMapping";

export const ActionTable = ({
  actionMetricsData,
  handleChange,
  sourceAliasIds,
  domaUrlsMapping,
  isBrandAudit = null,
  isShowPerformance=false,
  id="FocusArea"
}) => {
  const [open, setOpen] = useState(false);
  const [isopen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const [actionType, setActionType] = useState();
  const [isDataLoading, setIsDataLoading] = useState(false)
  const [nonActionsData, setNonActionsData] = useState([])
  const { user } = useContext(AuthContext);
  const discoveryCtx = useContext(DiscoveryContext);
  const customerId = user?.customer_id || 0;
  const isCompanyUser = user?.user_role?.role?.name === "Company user"

  const search = typeof window !== "undefined" ? window.location.search : "";
  const reporting = new URLSearchParams(search).get("reporting") === "true"

  // ---- reporting pagination (12 rows/page) ----
  const PAGE_SIZE = 12;
  const [reportPage, setReportPage] = useState(0);

  // use same sorted data everywhere
  const sortedData = sortRecommendedActionsData(actionMetricsData) || [];
  console.log("sortedData",sortedData,actionMetricsData)

  const pageCount = Math.max(1, Math.ceil(sortedData.length / PAGE_SIZE));
  const pageSlice = reporting
    ? sortedData.slice(reportPage * PAGE_SIZE, reportPage * PAGE_SIZE + PAGE_SIZE)
    : sortedData;

  // expose data-report-page on #print-pdf so the capturer can detect page index
  React.useEffect(() => {
    if (!reporting) return;
    const el = document.getElementById("print-pdf");
    if (el) el.setAttribute("data-report-page", String(reportPage));
  }, [reporting, reportPage]);



  const handleClose = () => setOpen(false);

  const handleNonActionModalClose = () => {
    setModalData([])
    setNonActionsData([])
    setIsOpen(false)
    setIsDataLoading(false)
  }

  const handleModalData = (data, type) => {
    setOpen(true);
    setModalData(data);
    setActionType(type);
  };

  const handleGoodScoreData = async (data, type) => {
    const dataLookup = {
      'sentiment': ['sentiment'],
      'reach': ['visibility'],
      'risk': ['product_taxonomy', 'brand_pillars', 'purchase_criteria']
    };

    const {
      brand,
      category,
      persona,
      llm,
      market,
      geography
    } = data;

    const payload = {
      customer_id: customerId,
      brand,
      category,
      persona,
      llm,
      market,
      geography,
      entityType: data?.isProduct ? 'product' : 'brand',
      isCompanyUser
    };

    setIsOpen(true);
    setIsDataLoading(true);

    try {
      const keysToExtract = dataLookup[type] || [];
      let result = {}
      if (!data?.nonActionsObj) {
        result = await getNonActionableMetricData(payload);
      }
      else {
        result = data?.nonActionsObj ?? {}
      }
      const mergedData = keysToExtract.flatMap(key => result[key] || []);
      setNonActionsData(mergedData)


      // update the state
      setModalData(data);
      setIsDataLoading(false);

    } catch (err) {
      setIsDataLoading(false);
      console.error('Error fetching data:', err);
    }
  };
  const isPropensity = discoveryCtx?.isPropensityToBuy?.() ?? (discoveryCtx?.brand_scores?.rbiType === "propensityToBuy");
  const mapTitle = (t) => discoveryCtx?.mapMetricTitle?.(t) ?? t;

  const headers = [
    (isBrandAudit ? isBrandAudit :`${ENTITY_LABELS.brand}/${ENTITY_LABELS.product}`),
    "Category",
    "LLM",
    "Persona",
    ...(isBrandAudit ? [] : ["Geography"]),
    "Market",
    isPropensity ? mapTitle(ENTITY_LABELS.rank) : ENTITY_LABELS.rank,
    isPropensity ? mapTitle("Sentiment") : "Sentiment",
     ...(isShowPerformance ? [] : ["Performance"]),
  ];

  if (!actionMetricsData || actionMetricsData.length === 0) {
    return;
  }

  const renderRowCells = (data) => {
    const reachCount = data?.Reach && data?.Reach.length;
    const sentimentCount = data?.Sentiment && data?.Sentiment.length;
    const riskCount = data?.Performance && data?.Performance.length;

    return (
      <>
        <td>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginLeft: "8px",
            }}
          >
            <img
              className={classes.logo}
              src={`https://img.logo.dev/${extractDomain(
                domaUrlsMapping?.[data?.brand]
              )}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
              alt={data?.brand}
            />
            <span style={{ textAlign: "left" }}>{data?.brand}</span>
          </div>
        </td>
        <td>{data?.category}</td>
        <td>{OVERVIEW_LLM_LABELS?.[data?.llm] || data?.llm}</td>
        <td>{data?.persona}</td>
        {!isBrandAudit && (
          <>
            <td>{data?.geography}</td>
          </>
        )}
        <td>{data?.market}</td>
        <td
          onClick={() => {
            reachCount
              ? handleModalData(data, "reach")
              : handleGoodScoreData(data, "reach");
          }}
          style={{ cursor: "pointer" }}
        >
          {reachCount ? (
            <CheckCircleIcon style={{ color: "#FC4C4E" }} />
          ) : (
            <DoNotDisturbOnRoundedIcon style={{ color: "#36CFC2" }} />
          )}
        </td>
        <td
          onClick={() => {
            sentimentCount
              ? handleModalData(data, "sentiment")
              : handleGoodScoreData(data, "sentiment");
          }}
          style={{ cursor: "pointer" }}
        >
          {sentimentCount ? (
            <CheckCircleIcon style={{ color: "#FC4C4E" }} />
          ) : (
            <DoNotDisturbOnRoundedIcon style={{ color: "#36CFC2" }} />
          )}
        </td>
        {!isShowPerformance &&
        <td
          onClick={() => {
            riskCount
              ? handleModalData(data, "risk")
              : handleGoodScoreData(data, "risk");
          }}
          style={{ cursor: "pointer" }}
        >
          {riskCount ? (
            <CheckCircleIcon style={{ color: "#FC4C4E" }} />
          ) : (
            <DoNotDisturbOnRoundedIcon style={{ color: "#36CFC2" }} />
          )}
        </td>
          }
      </>
    );
  };


  return (
    <div className="col-md-12">
      <ActionModal
        type={actionType}
        data={modalData}
        open={open}
        handleClose={handleClose}
        handleChange={handleChange}
        sourceAliasIds={sourceAliasIds}
      />

      <NonActionModal open={isopen} handleClose={handleNonActionModalClose} isDataLoading={isDataLoading} data={modalData} nonActionsData={nonActionsData} />

      {/* Reporting-only paginated modal (fixed size for screenshots) */}
      {reporting && (
        <div
          id="metric_detail"
          style={{
            position: "relative",
            background: "#fff",
            borderRadius: 12,
            width: "100%",
            height: 700, // 100 header + 600 capture = 700
            marginBottom: 24,
            overflow: "hidden",
            boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
          }}
        >
          {/* Modal header / controls (not part of screenshot) */}
          <div
            style={{
              height: 100,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "12px 16px",
              borderBottom: "1px solid #eee",
            }}
          >
            <div>
              <strong>Actions Dashboard</strong>
              <span style={{ marginLeft: 12, opacity: 0.7 }}>
                Page {reportPage + 1} / {pageCount}
              </span>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button
                id="report-prev"
                disabled={reportPage === 0}
                onClick={() => setReportPage((p) => Math.max(0, p - 1))}
              >
                Prev
              </button>
              <button
                id="report-next"
                disabled={reportPage >= pageCount - 1}
                onClick={() => setReportPage((p) => Math.min(pageCount - 1, p + 1))}
              >
                Next
              </button>
              <button id="close_id" onClick={() => { /* keep open for capture */ }}>
                Close
              </button>
            </div>
          </div>

          {/* Fixed capture area — backend screenshots this element */}
          <div
            id="print-pdf"
            data-report-page={reportPage}
            style={{
              width: "100%",
              height: 600,
              overflow: "hidden", // no scrollbars in screenshot
            }}
          >
            <table className="table table-striped" style={{ width: "100%" }}>
              <thead>
                <tr style={{ textAlign: "center" }} className="prdtblHeader">
                  {headers.map((header, index) => (
                    <th
                      key={header}
                      style={{
                        textAlign: index === 0 ? "left" : "center",
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                      }}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pageSlice.map((row, i) => (
                  <tr key={i} style={{ textAlign: "center", height: 44 }}>
                    {renderRowCells(row)}
                  </tr>
                ))}

                {/* pad last page to constant height */}
                {pageSlice.length < PAGE_SIZE &&
                  Array.from({ length: PAGE_SIZE - pageSlice.length }).map((_, i) => (
                    <tr key={`pad-${i}`} style={{ height: 44 }}>
                      {headers.map((_, j) => (
                        <td key={j}></td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}


      <div className={classes.tableContainer} id={id}>
        <table className="table table-striped">
          <thead
            style={{
              position: "sticky",
              top: 0,
            }}
          >
            <tr style={{ textAlign: "center" }} className="prdtblHeader">
              {headers.map((header, index) => (
                <th
                  style={{ textAlign: index === 0 ? "left" : "center" }}
                  key={header}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!!sortedData.length ? (
              sortedData.map((data, index) => (
                <tr style={{ textAlign: "center" }} key={index}>
                  {renderRowCells(data)}
                </tr>
              ))
            ) : (
              <div style={{ minHeight: "300px" }}></div>
            )}

          </tbody>
        </table>
      </div>
    </div>
  );
};
